import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import '../Styles/Footer.css';
import { FaWhatsapp, FaInstagram, FaFacebookF } from 'react-icons/fa';

const Footer = () => {
    const [socialMedia, setSocialMedia] = useState(null);

    useEffect(() => {
        const fetchSocialMedia = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/admin/social-media`);
                if (response.data && response.data.length > 0) {
                    setSocialMedia(response.data[0]);
                }
            } catch (error) {
                console.error('Error fetching social media:', error);
            }
        };
        fetchSocialMedia();
    }, []);

    const formatPhoneNumber = (whatsappUrl) => {
        if (!whatsappUrl || !whatsappUrl.includes('wa.me/')) return null;
        const number = whatsappUrl.split('wa.me/')[1];
        return `+${number}`;
    };

    const getDirectWhatsappLink = (link) => {
        if (!link) return '';
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile && link.includes('wa.me/')) {
            const number = link.split('wa.me/')[1];
            return `whatsapp://send?phone=${number}`;
        }
        return link;
    };

    return (

        <footer className="footer-container">
            <div className="footer-top">
                <div className="footer-brand">
                    <Link to="/" className="footer-logo-link" style={{ textDecoration: 'none' }}>
                        <h2 className="footer-text-logo">MÉGARA</h2>
                    </Link>
                    <p className="footer-description">
                        Curating modern elegance. Discover the essence of femininity with our premium collections designed for the contemporary woman.
                    </p>
                </div>

                <div className="footer-links-group">
                    <h4>Shop</h4>
                    <Link to="/shop">All Products</Link>
                    <Link to="/shop?filter=new">New Arrivals</Link>
                    <Link to="/shop?filter=sale">Limited Offers</Link>
                    <Link to="/shop?category=featured">Featured</Link>
                </div>

                <div className="footer-links-group">
                    <h4>Contact</h4>
                    {socialMedia?.whatsapp && formatPhoneNumber(socialMedia.whatsapp) ? (
                        <span className="contact-text" style={{ color: '#ccc', fontSize: '0.9rem', marginBottom: '14px' }}>
                            {formatPhoneNumber(socialMedia.whatsapp)}
                        </span>
                    ) : (
                        <span style={{ color: '#ccc', fontSize: '0.9rem', marginBottom: '14px' }}>Contact us</span>
                    )}
                </div>

                <div className="footer-links-group">
                    <h4>Policy</h4>
                    <span style={{ color: '#ccc', fontSize: '0.9rem', marginBottom: '8px', display: 'block' }}>
                        • No refund
                    </span>
                    <span style={{ color: '#ccc', fontSize: '0.9rem', marginBottom: '14px', display: 'block' }}>
                        • Exchange in 24 hours
                    </span>
                </div>


                <div className="footer-socials">
                    <a 
                        href={getDirectWhatsappLink(socialMedia?.whatsapp || "https://whatsapp.com")} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="social-icon"
                    >

                        <FaWhatsapp style={{ fontSize: '1.2rem', marginRight: '5px' }} /> 
                        WhatsApp
                    </a>
                    <a 
                        href={socialMedia?.instagram || "https://instagram.com"} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="social-icon"
                    >
                        <FaInstagram style={{ fontSize: '1.2rem', marginRight: '5px' }} /> 
                        Instagram
                    </a>
                    <a 
                        href={socialMedia?.facebook || "https://facebook.com"} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="social-icon"
                    >
                        <FaFacebookF style={{ fontSize: '1.2rem', marginRight: '5px' }} /> 
                        Facebook
                    </a>
                </div>




            </div>

            <div className="footer-bottom">
                <div className="footer-copyright">
                    &copy; Laptop Company. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;

